<!--
 * @Description: 传发官网首页
-->
<template>
  <div id="home" class="home">
    <!-- 首页 -->
    <header-view></header-view>

    <div class="banner"></div>
    <div class="plan">
      <div class="plan-content">
        <div class="plan-heading"></div>
        <div class="plan-items">
          <div class="plan-item plan-item-operation" role="img" aria-label="集中作业处理"></div>
          <div class="plan-item plan-item-profile" role="img" aria-label="贷前处理、客户画像"></div>
          <div class="plan-item plan-item-service" role="img" aria-label="客户服务"></div>
        </div>
      </div>
    </div>
    <div class="power">
      <img class="img" src="../assets/images/i2.png" alt="" />
    </div>
    <div class="about">
      <div class="img">
        <img src="../assets/images/i3.png" alt="" />
        <div class="about-copy">
          <h3>缔造“传”奇，不负时代，不负“发”样年华</h3>
          <p>
            传发金融是一家专业的金融服务公司，立志打造互金行业标杆企业，为战略合作伙伴业务保驾护航，提供高标准、全流程的贷后服务，目前已相继在北京、南京、武汉、合肥等地设立自营中心。
          </p>
        </div>
        <router-link class="goAbout" :to="{ path: '/about' }">
          <img id="" src="../assets/images/i31.png" alt="" />
        </router-link>
      </div>
    </div>
    <div class="contact">
      <div class="contact-title">
        <img class="img" src="../assets/images/contactus.png" />
      </div>

      <div class="contact-wrap">
        <div class="contact-1">
          <p>
            <img src="../assets/images/location.png" alt="" />
          </p>
          <p class="contact-wrap-title">上海中心</p>
          <p class="contact-wrap-content">
            地处浦东新区张江高科技园区核心区，以完善的设施、优美的环境和优质的配套服务成为科技领袖集聚之地。
          </p>
          <div class="contact-wrap-detail">
            <p>办公地址：张江高科技园区核心区，约1900平方</p>
            <p>联系人员：罗明权</p>
            <p>联系邮箱：mingquan.luo@cf-fis.com</p>
            <p>招聘热线：18326115160</p>
          </div>
        </div>
      </div>
      <!-- <img class="img" src="../assets/images/i4.png" alt=""> -->
    </div>

    <footer-view></footer-view>
  </div>
</template>

<script>
import HeaderView from '@/components/header.vue'
import FooterView from '@/components/footer.vue'

export default {
  name: 'homeView',

  components: {
    HeaderView,
    FooterView
  }
}
</script>

<style lang="stylus">
.home, >div {
  width: 100%;
}

.img {
  display: block;
  width: 1200px;
  margin: 0 auto;
}

.banner {
  height: 505px;
  background: url('../assets/images/banner1-clean.png') no-repeat;
  background-size: cover;
  background-position: center;
}

.plan {
  height: 454px;

  .plan-content {
    width: 1200px;
    height: 454px;
    margin: 0 auto;
  }

  .plan-heading {
    width: 1200px;
    height: 154px;
    background: url('../assets/images/i1.png') no-repeat 0 0;
  }

  .plan-items {
    display: flex;
    width: 900px;
    height: 300px;
    margin: 0 auto;
  }

  .plan-item {
    flex: 0 0 300px;
    height: 300px;
    background-image: url('../assets/images/i1.png');
    background-repeat: no-repeat;
  }

  .plan-item-operation {
    background-position: 0 -154px;
  }

  .plan-item-profile {
    background-position: -300px -154px;
  }

  .plan-item-service {
    background-position: -900px -154px;
  }
}

.power {
  background: url('../assets/images/bg1.png') no-repeat;
  background-size: cover;
  background-position: center;
  height: 660px;
}

.about {
  height: 503px;

  .img {
    position: relative;

    img {
      width: 100%;
      height: 100%;
    }

    .goAbout {
      position: absolute;
      top: 366px;
      left: 486px;
    }

    .about-copy {
      position: absolute;
      top: 112px;
      left: 474px;
      width: 726px;
      height: 245px;
      padding: 28px 30px 20px 36px;
      background: #fff;

      h3 {
        margin-bottom: 22px;
        color: #242427;
        font-size: 24px;
        font-weight: 400;
        letter-spacing: 2px;
      }

      p {
        color: #999;
        font-size: 16px;
        line-height: 28px;
      }
    }
  }
}

.contact {
  background-color: #f8f8f8;
  height: 528px;
}

.contact-wrap {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  overflow: hidden;

  div {
    width: 548px;
    text-align: center;
  }

  .contact-1 {
    margin: 0 auto;
  }

  .contact-wrap-title {
    font-size: 22px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #242427;
    line-height: 30px;
    margin-bottom: 15px;
  }

  .contact-wrap-content {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #242427;
    line-height: 22px;
    margin-bottom: 33px;
    padding: 0 53px;
  }

  .contact-wrap-detail {
    width: 442px;
    height: 189px;
    background: #FFFFFF;
    padding: 19px 45px 37px 45px;
    margin: 0 auto;

    p {
      text-align: left;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #464647;
      line-height: 32px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue